import { FC } from 'react';

export const IconCollapseRight: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="currentColor"
  >
    <path d="M5 1v18h2v-8h7.586l-3.293 3.293 1.414 1.414L18.415 10l-5.708-5.707-1.414 1.414L14.586 9H7V1H5Z" />
  </svg>
);
